import React from 'react'
import Helmet from 'react-helmet'
import { Container } from 'reactstrap'

import Layout from 'layouts/static'

import H2 from 'components/H2'
import H4 from 'components/H4'

const PrivacyPolicyPage = () => (
  <Layout>
    <Helmet title="Privacy Policy - Karer Media" />
    <Container className="pt-5 pb-5">
      <H2 className="text-center">Privacy Policy</H2>
      <p>Last updated: October 25, 2026</p>

      <H4>1. Controller</H4>
      <p>
        Karer Solutions GmbH, Kulmbacher Str. 68, 95445 Bayreuth, Germany
        (Amtsgericht Bayreuth, HRB 7361), operating as Karer Media
        ("we", "us"). Contact: info@karermedia.com.
      </p>

      <H4>2. Scope</H4>
      <p>
        This policy covers the website karermedia.com and Karer Ads Tool, an
        internal application we use to manage our own Google Ads accounts
        through the Google Ads API.
      </p>

      <H4>3. Website</H4>
      <p>
        When you visit this website, our hosting provider processes technical
        data such as your IP address, browser type and the time of access in
        server logs to deliver the site and keep it secure (Art. 6(1)(f) GDPR).
        If you contact us by e-mail, we process the data you send us only to
        answer your request (Art. 6(1)(b) and (f) GDPR).
      </p>

      <H4>4. Karer Ads Tool and Google user data</H4>
      <p>
        Karer Ads Tool is used only by our own staff. When an authorized user
        signs in with Google, the tool requests the Google Ads API scope
        (https://www.googleapis.com/auth/adwords) to read and manage Google Ads
        accounts that the user already has access to: account structure,
        campaigns, keywords, ads, budgets, performance reports and keyword
        planning data.
      </p>
      <p>
        OAuth credentials are stored only on the user's own device. Google Ads
        data is used only to plan, run and report on advertising for the
        accounts concerned. We do not sell Google user data, do not share it
        with third parties, do not use it for advertising profiles and do not
        use it to train generalized AI or machine learning models.
      </p>
      <p>
        Karer Ads Tool's use and transfer of information received from Google
        APIs adheres to the{' '}
        <a href="https://developers.google.com/terms/api-services-user-data-policy">
          Google API Services User Data Policy
        </a>
        , including the Limited Use requirements.
      </p>
      <p>
        You can revoke the tool's access at any time at{' '}
        <a href="https://myaccount.google.com/permissions">
          myaccount.google.com/permissions
        </a>
        .
      </p>

      <H4>5. Retention</H4>
      <p>
        We keep personal data only as long as needed for the purposes above or
        as required by law. Server logs are deleted by the hosting provider
        within its standard retention period.
      </p>

      <H4>6. Your rights</H4>
      <p>
        Under the GDPR you have the right to access, rectify, erase, restrict
        and port your data, and to object to processing. You may also lodge a
        complaint with a supervisory authority, for example the Bavarian Data
        Protection Authority (BayLDA). To exercise your rights, write to
        info@karermedia.com.
      </p>

      <H4>7. Changes</H4>
      <p>
        We may update this policy. The current version is always available on
        this page.
      </p>
    </Container>
  </Layout>
)

export default PrivacyPolicyPage
